import * as AuthConstants from "../constants/auth.constant";
import { Loading } from "../utils/helpers/constants";

const initialState = {
  isAuthenticated: false,
  loginStatus: "",
  forgotPasswordLoading: "",
  resetPasswordLoading: "",
  createPasswordLoading: "",
  userType: "",
  authorities: [],
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case AuthConstants.LOGIN_REQUEST:
      return { ...state, loginStatus: Loading.FETCHING };

    case AuthConstants.LOGIN_SUCCESS:
      return {
        ...state,
        ...action.payload,
        isAuthenticated: true,
        loginStatus: Loading.SUCCESS,
        userType: action.payload.userType,
        userId: action.payload.userId,
        authorities: action.payload.roles,
      };
    case AuthConstants.LOGIN_FAILURE:
      return { ...state, loginStatus: Loading.ERROR };

    case AuthConstants.FORGOT_PASSWORD_REQUEST:
      return { ...state, forgotPasswordLoading: Loading.FETCHING };

    case AuthConstants.FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        forgotPasswordLoading: Loading.SUCCESS,
      };

    case AuthConstants.FORGOT_PASSWORD_FAILURE:
      return { ...state, forgotPasswordLoading: Loading.ERROR };

    case AuthConstants.RESET_PASSWORD_REQUEST:
      return { ...state, resetPasswordLoading: Loading.FETCHING };

    case AuthConstants.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPasswordLoading: Loading.SUCCESS,
      };
    case AuthConstants.RESET_PASSWORD_FAILURE:
      return { ...state, resetPasswordLoading: Loading.ERROR };

    case AuthConstants.CREATE_PASSWORD_REQUEST:
      return { ...state, createPasswordLoading: Loading.FETCHING };

    case AuthConstants.CREATE_PASSWORD_SUCCESS:
      return {
        ...state,
        createPasswordLoading: Loading.SUCCESS,
      };
    case AuthConstants.CREATE_PASSWORD_FAILURE:
      return { ...state, createPasswordLoading: Loading.ERROR };

    default:
      return state;
  }
};

export default authReducer;
